module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Zmień swoje hasło")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło",
      "name": "password",
      "type": "password",
      "validation-rules": "required|min:6|max:16",
      "validation-messages": _vm.errorMessages,
      "autocomplete": "off",
      "help-text": "Wybierz nowe hasło które ma minimum 6 znaków i maksimum 18"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło (powtórz)",
      "name": "password2",
      "type": "password",
      "validation-rules": "required|min:6|max:16",
      "validation-messages": _vm.errorMessages,
      "autocomplete": "off",
      "help-text": "Powtórz hasło wpisane wyżej"
    },
    model: {
      value: (_vm.form.password2),
      callback: function($$v) {
        _vm.form.password2 = $$v
      },
      expression: "form.password2"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Zmień hasło")]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "default"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'admin.my'
        })
      }
    }
  }, [_vm._v("Anuluj")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd8b4a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/ChangePassword.vue
// module id = 271
// module chunks = 0